var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.57 23.7125C30.835 24.43 30.415 25.4625 30.52 26.565C30.6775 28.455 32.41 29.8375 34.3 29.8375H37.625V31.92C37.625 35.5425 34.6675 38.5 31.045 38.5H10.955C7.3325 38.5 4.375 35.5425 4.375 31.92V20.1425C4.375 16.52 7.3325 13.5625 10.955 13.5625H31.045C34.6675 13.5625 37.625 16.52 37.625 20.1425V22.6625H34.09C33.11 22.6625 32.2175 23.0475 31.57 23.7125Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 21.7175V13.7201C4.375 11.6376 5.6525 9.78254 7.595 9.04754L21.49 3.79754C23.66 2.97504 25.9875 4.5851 25.9875 6.9126V13.5626",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4779 24.4478V28.0529C39.4779 29.0154 38.7079 29.8028 37.7279 29.8378H34.2979C32.4079 29.8378 30.6754 28.4553 30.5179 26.5653C30.4129 25.4628 30.8329 24.4303 31.5679 23.7128C32.2154 23.0478 33.1079 22.6628 34.0879 22.6628H37.7279C38.7079 22.6978 39.4779 23.4853 39.4779 24.4478Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 21H24.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.c6fb42cf99094e06c15f26ea3a9562c7.svg";
export { ForwardRef as ReactComponent };